import { connect } from 'react-redux';
import Transcripts from './Transcripts';

const mapStateToProps = state => ({
    supportedLanguages: state.i18n.supportedLanguages,
});

export default connect(mapStateToProps)(Transcripts);
